import { disputeDeflectionSchema_ } from "@redotech/redo-dispute-db-schema/dispute-deflection-definition";
import * as z from "zod";

/**
 * The deflection (RESOLVE) row as served to the merchant RESOLVE list/detail and
 * the admin RESOLVE tab. Drops `rawRequest` / `responseBody` (heavy verbatim
 * payloads — loaded only on the detail view); keeps the rest. `accountId` stays
 * for the admin merchant join — the merchant UI ignores it. Mirrors
 * disputeAlertViewSchema.
 */
const disputeDeflectionViewSchema_ = disputeDeflectionSchema_.omit({
  rawRequest: true,
  responseBody: true,
});

export const disputeDeflectionViewSchema: z.ZodType<DisputeDeflectionView> =
  disputeDeflectionViewSchema_;

export interface DisputeDeflectionView extends z.infer<
  typeof disputeDeflectionViewSchema_
> {}

// Exported raw object so the admin row schema can `.extend` it (teamName/teamId).
export { disputeDeflectionViewSchema_ };
